module.exports = __webpack_public_path__ + "static/img/side_menu.870d27c0.png";